const Loading = () => {
    return null;
}

export default Loading;